/* eslint-disable @typescript-eslint/no-shadow */
import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import classnames from 'classnames';
import T from 'i18n';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import FileDropZone from '../../common/FileDropZone';
import DocumentsModal from '../DocumentsModal';
import { documentModalActions, fileTypes } from '../enums';
import { diff } from 'deep-object-diff';

import TableCase from '../TableCase';
import history from 'common/history';
import { useDispatch, useSelector } from 'react-redux';
import { assignDocuments } from '../redux/assignDocuments';
import { unassignDocuments } from '../redux/unassignDocuments';
import { updateDocumentMeta } from '../redux/updateDocumentMeta';
import { updateDocument } from '../redux/updateDocument';
import { replaceFile } from '../redux/replaceFile';
import { duplicateFile } from '../redux/duplicateFile';
import { generateHyperlinks } from '../redux/generateHyperlinks';
import { updateReferences } from '../redux/updateReferences';
import { takeReference } from '../redux/takeReference';
import { takeReferenceWithNames } from '../redux/takeReferenceWithNames';
import { fetchExhibitChanges } from '../redux/fetchExhibitChanges';
import FolderFooter from './FolderFooter';
import FolderBreadcrumb from './FolderBreadcrumb';
import equal from 'react-fast-compare';
import { openNewBackgroundTab } from 'utils/browser';
import { fetchFolderSpecificFileDetails } from '../redux/fetchFolderSpecificFileDetails';
import { uploadTranscriptNotes } from '../redux/uploadTranscriptNotes';
import {
  selectPermissions,
  selectDocuments,
  selectDocumentCount,
  selectTotalPageCount,
  selectCurrentFolderId,
  selectTotalDocumentsCount,
  selectCurrentFolder,
  selectTotalDocumentSize,
  selectParams,
  selectCurrentFolderAgreed,
  selectIsGlobalPageLookup,
  selectCurrentCaseId,
  selectFetchDocumentsPending,
  selectCurrentSelectedFileMetaData,
  selectDocFinderFilter,
  selectIsLocalUploadDrawerOpen,
  selectQuery,
  selectUserSettingPresentMode,
  selectCurrentFile,
  selectGlobalSideBarOpen,
  selectEnableRemovePages,
  selectUserId,
} from 'common/selectors';
import { useFetchFileDetails } from '../redux/fetchFileDetails';
import { useFetchAnnotations } from 'features/viewing/redux/fetchAnnotations';
import SideDrawer from '../SideDrawer';
import UploadFileContent from './UploadFileContent';
import { setCurrentSelectedFile } from '../redux/setCurrentSelectedFile';
import { BatchUploadReport, FileMetaData } from './types';
import UploadStatusWindow from './UploadStatusWindow';
import { usePrevious } from 'utils/hooks';
import DocFinderFilters from './DocFinderFilters';
import { useSetShowDocFinderFilter } from '../redux/setShowDocFinderFilter';
import { setLocalUploadDrawer } from 'features/globalUpload/redux/uploadDrawer';
import { setSidebarOpen, setSummaryOpen } from 'features/common/redux/navbarLayout';
import { CircularProgress } from '@mui/material';
import { setFileToCompare } from '../redux/setFileToCompare';
import { setLastSelectedFile } from '../redux/setLastSelectedFile';
import { resetAskAiSse } from '../redux/askAiSse';
import { clearAISearchState } from '../redux/setAISearchState';
import DataMapper from './DataMapper';
import IManageDrawerContent from './IManageDrawerContent';
import IManageJobSummaryDialog from './IManageJobSummaryDialog';
import { useBatchProcess } from './useBatchProcess';
import { useIManageBatchUpload } from './useIManageBatchUpload';
import LateInsertModal from './components/LateInsertModal';
import CreatePlaceholdersModal from './components/CreatePlaceholdersModal';
import { uploadFiles } from '../redux/uploadFiles';
import { v4 as uuidv4 } from 'uuid';
import { compareTabValues, normalizeTabValue } from './tabUtils';
import { useFilteredAndSortedData } from '../redux/setFilteredAndSortedData';
import FocusView from './FocusView';
import { useFocusViewBridge } from '../FocusViewBridge';
import { areAllDocumentsMerged } from './utils/aiToolsMergeHelpers';
import { fetchDocuments, fetchFolder } from '../redux/actions';

const getFocusParamId = (doc: any) =>
  doc?.fileId || doc?.id || doc?.folderFileId || doc?.compositeKey || null;
const matchesFocusParam = (doc: any, focusId: string) => {
  if (!doc || !focusId) return false;
  const focusValue = String(focusId);
  const candidates = [doc.fileId, doc.id, doc.folderFileId, doc.compositeKey];
  return candidates.some((value) => value != null && String(value) === focusValue);
};

export default ({ category }: any) => {
  const [selectedRows, setSelectedRows] = useState<Array<any>>([]);
  const [showModal, setShowModal] = useState(false);
  const [fileMetadata, setFileMetadata] = useState<FileMetaData[]>([]);
  const [modalAction, setModalAction] = useState('null');
  const [filteredRowCount, setFilteredRowCount] = useState(null);
  const [filterValue, setFilterValue] = useState('');
  const [filterCategory, setFilterCategory] = useState(null);
  const [gridList, setGridList] = useState<any[]>([]);
  const [uploadInnerFile, setUploadInnerFile] = useState<boolean>(false);

  const [lateInsertFiles, setLateInsertFiles] = useState<File[]>([]);
  const [lateInsertAssignments, setLateInsertAssignments] = useState<Record<string, string>>({});
  const [lateInsertModalOpen, setLateInsertModalOpen] = useState(false);
  const [lateInsertBatchId, setLateInsertBatchId] = useState<string | null>(null);
  const [lateInsertUploadInnerFile, setLateInsertUploadInnerFile] = useState(false);
  const [lateInsertSubmitted, setLateInsertSubmitted] = useState(false);
  const [createPlaceholdersModalOpen, setCreatePlaceholdersModalOpen] = useState(false);
  const [viewDrawerOpen, setViewDrawerOpen] = useState(false);
  const [viewDrawerFile, setViewDrawerFile] = useState<any | null>(null);
  const [viewDrawerPending, setViewDrawerPending] = useState(false);
  const [viewDrawerError, setViewDrawerError] = useState(false);
  const [viewDrawerBundleDetails, setViewDrawerBundleDetails] = useState<any>({});
  const viewDrawerZIndex = 100000;
  const [focusViewEntered, setFocusViewEntered] = useState(false);
  const [openFileLoading, setOpenFileLoading] = useState(false);

  const { file: alreadyOpenFileId, quickLink } = useSelector(selectParams) as any;
  const documents = useSelector(selectDocuments) as Array<any>;
  const currentFolder = useSelector(selectCurrentFolder) as any;
  const permissions = useSelector(selectPermissions);
  const documentCount = useSelector(selectDocumentCount);
  const totalPageCount = useSelector(selectTotalPageCount);
  const currentFolderId = useSelector(selectCurrentFolderId);
  const prevFolderId = usePrevious(currentFolderId);
  const totalDocumentCount = useSelector(selectTotalDocumentsCount);
  const fetchDocumentsPending = useSelector(selectFetchDocumentsPending);
  const totalDocumentSize = useSelector(selectTotalDocumentSize);
  const currentFileMetaData = useSelector(selectCurrentSelectedFileMetaData);
  const hasDocFinderFilter = useSelector(selectDocFinderFilter);
  const isSidebarOpen = useSelector(selectGlobalSideBarOpen);
  const isTrialBooks = category === T.translate('case.trialbooks');
  const isAllDocuments = category === T.translate('case.allDocuments');
  const isRecycleBin = category === T.translate('case.recycleBin');
  const isAllDocumentsView = isAllDocuments || isRecycleBin;
  const isQuickLinksPage = category === T.translate('case.quickLinks');
  const isTagsPage = quickLink === 'tags';
  const isPresentModePage = category === T.translate('case.presentViewTitle');
  const isPresentModeWithBackEnd = false;
  const isSearchModePage = category === T.translate('case.searchMode');
  const isAiToolsPage = category === T.translate('generic.aiTools');
  const isDocFinderPage = category === T.translate('case.docFinder');
  const isAgreedBundle = useSelector(selectCurrentFolderAgreed);
  const isMacPlatform =
    typeof navigator !== 'undefined' &&
    typeof navigator.platform === 'string' &&
    navigator.platform.toLowerCase().includes('mac');
  const canPresentToHearingRoom = permissions?.hearingRoom?.canPresent?.('public');
  const showPresentModeWithSearch = useSelector(selectUserSettingPresentMode) && canPresentToHearingRoom;
  const canDuplicateDocuments = permissions?.documents?.duplicate === true;
  const enableRemovePages = useSelector(selectEnableRemovePages);

  const showSidebar = useSelector(selectIsLocalUploadDrawerOpen);
  const showAIIcon = documents?.length > 0 && !fetchDocumentsPending;
  const hideAiToolsForMergedDocuments = useMemo(
    () => areAllDocumentsMerged(documents),
    [documents],
  );
  const { fetchFileDetails } = useFetchFileDetails();
  const { filteredAndSortedData } = useFilteredAndSortedData();
  const dispatch = useDispatch();
  const focusViewBridge = useFocusViewBridge();
  const { fetchAnnotations } = useFetchAnnotations();

  const dropzoneRef = useRef<any>();
  const sidebarWasOpenRef = useRef(false);
  const prevFocusViewEnteredRef = useRef(false);
  const focusViewEnteredRef = useRef(focusViewEntered);
  const viewDrawerOpenRef = useRef(viewDrawerOpen);

  const handleCloseModal = () => setShowModal(false);
  const handleOpenCreatePlaceholdersModal = useCallback(() => {
    setCreatePlaceholdersModalOpen(true);
  }, []);
  const handleCloseCreatePlaceholdersModal = useCallback(() => {
    setCreatePlaceholdersModalOpen(false);
  }, []);

  const openDialog = () => {
    if (dropzoneRef.current) {
      if (uploadInnerFile) setUploadInnerFile(false);
      dropzoneRef.current.open();
    }
  };

  const openDialogCR = () => {
    if (dropzoneRef.current) {
      setUploadInnerFile(true);
      dropzoneRef.current.open();
    }
  };

  const getFileData = (data: any, folderSpecificData: any) => {
    const folderSpecificProp = ['name', 'tab', 'startPage'];
    return {
      ...Object.entries(data).reduce((previousItem, [key, value]) => {
        return folderSpecificData
          ? folderSpecificProp.includes(key)
            ? { ...previousItem, [key]: value }
            : previousItem
          : !folderSpecificProp.includes(key)
            ? { ...previousItem, [key]: value }
            : previousItem;
      }, {}),
    };
  };
  const normalizeTab = useCallback((value: any) => normalizeTabValue(value), []);
  const compareTabs = useCallback((a: string, b: string) => compareTabValues(a, b), []);
  const incrementTabValue = useCallback((tab: string) => {
    const segments = tab.split('.');
    // If no decimal, add .1
    if (segments.length === 1) {
      return `${segments[0]}.1`;
    }
    const last = segments[segments.length - 1];
    const lastNum = parseInt(last, 10);
    if (!Number.isFinite(lastNum)) return `${tab}.1`;
    const nextLast = String(lastNum + 1).padStart(last.length, '0');
    segments[segments.length - 1] = nextLast;
    return segments.join('.');
  }, []);

  const availableTabs = useMemo(() => {
    const folderTabsRaw = Array.isArray((currentFolder as any)?.tabs)
      ? (currentFolder as any).tabs
      : [];
    const folderTabs = folderTabsRaw.map(normalizeTab).filter(Boolean);

    const docTabs = (documents || [])
      .map((doc: any) =>
        normalizeTab(doc.tab || (doc.bundleLocations && doc.bundleLocations[0]?.tab)),
      )
      .filter(Boolean);

    const combinedSet = new Set<string>([...folderTabs, ...docTabs]);
    if (combinedSet.size === 0 && currentFolder?.fileCount) {
      const count = Number(currentFolder.fileCount) || 0;
      if (count > 0) {
        const start = currentFolder?.zeroBasedIndex ? 0 : 1;
        for (let i = 0; i < count; i += 1) {
          combinedSet.add(String(start + i));
        }
      }
    }
    const combined = Array.from(combinedSet);
    combined.sort(compareTabs);
    return combined;
  }, [currentFolder, documents, normalizeTab, compareTabs]);

  const existingFiles = useMemo(
    () =>
      (documents || [])
        .map((doc: any) => ({
          name: doc.name,
          tab: normalizeTab(doc.tab || (doc.bundleLocations && doc.bundleLocations[0]?.tab)),
        }))
        .filter((f: any) => f.tab)
        .sort((a: any, b: any) => compareTabs(a.tab, b.tab)),
    [documents, normalizeTab, compareTabs],
  );

  const getFolderSpecificCleanData = (data: any, file: any, forceDirtyKeys: string[] = []) => {
    const cleanData = {
      ...Object.entries(data).reduce((a, [k, v]) => {
        if (forceDirtyKeys.includes(k)) {
          return { ...a, [k]: v };
        }
        return (v === '' && file[k] === data[k]) || file[k] === data[k] ? a : { ...a, [k]: v };
      }, {}),
    };
    return cleanData;
  };

  const handleSave = (
    folderId: any,
    action: any,
    documents: any,
    data: any,
    handleClose: any,
    setLoading: any,
  ) => {
    switch (action) {
      case documentModalActions.copy:
        dispatch(
          assignDocuments({
            documentIds: documents.map(
              ({ compositeKey }: { compositeKey: string }) => compositeKey,
            ),
            folderId: folderId,
          }),
        );
        break;
      case documentModalActions.duplicate:
        {
          const targetDoc = documents[0];
          const duplicateName = String(data?.name || '').trim();
          if (!canDuplicateDocuments || !currentFolderId || !targetDoc?.id || !duplicateName) {
            setLoading && setLoading(false);
            handleClose && handleClose();
            break;
          }
          dispatch(
            duplicateFile({
              folderId: currentFolderId,
              fileId: targetDoc.id,
              body: { name: duplicateName },
            }),
          ).finally(() => {
            setLoading && setLoading(false);
            handleClose && handleClose();
          });
        }
        break;
      case documentModalActions.remove:
        dispatch(unassignDocuments(documents));
        break;
      case documentModalActions.updateMeta:
        if (isAllDocumentsView) dispatch(updateDocumentMeta(data, documents[0].id));
        else {
          const hasFolderSpecificChange =
            data.name !== documents[0].name ||
            data.tab !== documents[0].tab ||
            data.startPage !== documents[0].startPage;
          const resolvedStartPage = data.startPage ?? documents[0].startPage;
          const hasStartPageValue =
            resolvedStartPage !== '' &&
            resolvedStartPage !== null &&
            resolvedStartPage !== undefined;
          const shouldForceStartPageUpdate =
            isAgreedBundle && !documents[0]?.agreed && hasStartPageValue;
          if (hasFolderSpecificChange || shouldForceStartPageUpdate) {
            const folderSpecificData = getFileData(
              shouldForceStartPageUpdate ? { ...data, startPage: resolvedStartPage } : data,
              true,
            );
            const cleanData = getFolderSpecificCleanData(
              folderSpecificData,
              documents[0],
              shouldForceStartPageUpdate ? ['startPage'] : [],
            );
            if (Object.keys(cleanData).length > 0) {
              dispatch(updateDocument(cleanData, documents[0].id, documents[0].folderFileId));
            }
          }
          const fileMetaData = getFileData(data, false);
          if (Object.keys(fileMetaData).length > 1) {
            dispatch(updateDocumentMeta(fileMetaData, documents[0].id));
          }
        }
        break;
      case documentModalActions.updateReferences:
        {
          const targetDoc = documents[0];
          const fileType = (targetDoc?.type || '').toLowerCase();
          const isDocxFile = fileType === 'docx';
          if (isDocxFile) {
            dispatch(
              updateReferences(targetDoc.id, {
                presentMode: isPresentModePage,
                recycleBin: isRecycleBin,
              }),
            ).finally(() => {
              setLoading && setLoading(false);
              handleClose();
            });
          } else {
            setLoading && setLoading(false);
            handleClose();
          }
        }
        break;
      case documentModalActions.takeReference:
        {
          const targetDoc = documents[0];
          const fileName = (targetDoc?.name || targetDoc?.originalName || '') as string;
          dispatch(
            takeReference(targetDoc.id, {
              presentMode: isPresentModePage,
              recycleBin: isRecycleBin,
              fileName,
            }),
          ).finally(() => {
            setLoading && setLoading(false);
            handleClose();
          });
        }
        break;
      case documentModalActions.takeReferenceWithNames:
        {
          const targetDoc = documents[0];
          const fileName = (targetDoc?.name || targetDoc?.originalName || '') as string;
          dispatch(
            takeReferenceWithNames(targetDoc.id, {
              presentMode: isPresentModePage,
              recycleBin: isRecycleBin,
              fileName,
            }),
          ).finally(() => {
            setLoading && setLoading(false);
            handleClose();
          });
        }
        break;
      case documentModalActions.exhibitChanges:
        {
          const targetDoc = documents[0];
          const fileType = (targetDoc?.type || '').toLowerCase();
          const isDocxFile = fileType === 'docx';
          if (isDocxFile) {
            dispatch(fetchExhibitChanges(targetDoc.id)).finally(() => {
              setLoading && setLoading(false);
              handleClose();
            });
          } else {
            setLoading && setLoading(false);
            handleClose();
          }
        }
        break;
      case documentModalActions.replace:
        dispatch(replaceFile(data, documents[0].id))
          .then(() => {
            setLoading(false);
            handleClose();
          })
          .catch(() => {
            setLoading(false);
          });
        break;
      case documentModalActions.uploadTranscriptNotes:
        dispatch(
          uploadTranscriptNotes(data.newFile[0], data.onBehalfOfUserId, documents[0].id),
        ).finally(() => {
          setLoading(false);
          handleClose();
        });
        break;
      case documentModalActions.generateHyperlinks:
        dispatch(generateHyperlinks({ ...data, useFileNames: true }, documents[0].id)).finally(
          () => {
            setLoading(false);
            handleClose();
          },
        );
        break;
      case documentModalActions.generateTranscriptsbasedHyperlinks:
        dispatch(generateHyperlinks({ ...data, isTranscript: true }, documents[0].id)).finally(
          () => {
            setLoading(false);
            handleClose();
          },
        );
        break;
      case documentModalActions.findAndReplaceHyperlinks:
        dispatch(
          generateHyperlinks(
            { ...data, autoGenHyperlinksFromPageRefs: !data.useAllExternalIDs },
            documents[0].id,
          ),
        ).finally(() => {
          setLoading(false);
          handleClose();
        });
        break;
      default:
    }
  };

  const resetLateInsertState = useCallback(() => {
    setLateInsertFiles([]);
    setLateInsertAssignments({});
    setLateInsertBatchId(null);
    setLateInsertUploadInnerFile(false);
    setLateInsertSubmitted(false);
    setLateInsertModalOpen(false);
  }, []);

  const handleLateInsertAssignmentChange = useCallback((fileName: string, tab: string | number) => {
    setLateInsertAssignments((prev) => ({ ...prev, [fileName]: String(tab) }));
  }, []);

  const handleLateInsertRemoveFile = useCallback(
    (fileName: string) => {
      setLateInsertFiles((prev) => {
        const next = prev.filter((file) => file.name !== fileName);
        if (next.length === 0) {
          resetLateInsertState();
          return [];
        }
        return next;
      });
      setLateInsertAssignments((prev) => {
        const next = { ...prev };
        delete next[fileName];
        return next;
      });
    },
    [resetLateInsertState],
  );

  const handleLateInsertDrop = useCallback(
    (
      acceptedFiles: File[],
      context?: { batchId: string; uploadInnerFile?: boolean; folderId?: string },
    ) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return;
      const nextBatchId = context?.batchId || uuidv4();
      const nextAssignments: Record<string, string> = {};
      acceptedFiles.forEach((file, idx) => {
        const backendTab = (currentFolder as any)?.lateInsertTabs?.[idx];
        if (backendTab) {
          nextAssignments[file.name] = String(backendTab);
        }
      });
      setLateInsertAssignments(nextAssignments);
      setLateInsertFiles(acceptedFiles);
      setLateInsertBatchId(nextBatchId);
      setLateInsertUploadInnerFile(Boolean(context?.uploadInnerFile));
      if (context?.uploadInnerFile) {
        setUploadInnerFile(false);
      }
      setLateInsertSubmitted(false);
      setLateInsertModalOpen(true);
    },
    [currentFolder],
  );

  const handleLateInsertSubmit = useCallback(() => {
    if (!lateInsertFiles.length || !lateInsertBatchId) return;
    const tabAssignments: Record<string, string> = {};
    lateInsertFiles.forEach((file) => {
      const selectedTab = lateInsertAssignments[file.name];
      if (typeof selectedTab === 'string' && selectedTab.trim().length > 0) {
        tabAssignments[file.name] = selectedTab.trim();
      }
    });
    dispatch(
      uploadFiles(
        lateInsertFiles,
        currentFolderId,
        lateInsertUploadInnerFile,
        lateInsertBatchId,
        tabAssignments,
      ),
    );
    resetLateInsertState();
    setLateInsertSubmitted(true);
  }, [
    currentFolderId,
    dispatch,
    lateInsertAssignments,
    lateInsertBatchId,
    lateInsertFiles,
    lateInsertUploadInnerFile,
    resetLateInsertState,
  ]);

  const onRowSelected = useCallback((selectedRowsNew: any) => {
    setSelectedRows((prevSelectedRows) => {
      if (!equal(selectedRowsNew, prevSelectedRows)) {
        return selectedRowsNew;
      }
      return prevSelectedRows;
    });
  }, []);

  // Prevent re-entrant filter clearing loops when Table triggers onFilterChanged
  const clearingFiltersRef = useRef(false);
  const onFilterChanged = (filteredRows: any, value: any) => {
    // Only clear DocFinder filters if that panel is present and we're not already clearing
    if (!clearingFiltersRef.current && showDocFinderFilter) {
      clearingFiltersRef.current = true;
      try {
        filterRef.current?.clearFilters?.();
      } finally {
        // Defer reset to end of tick allowing any state updates to settle
        setTimeout(() => {
          clearingFiltersRef.current = false;
        }, 0);
      }
    }

    setFilteredRowCount(filteredRows && filteredRows.length);
    setFilterValue(value);
  };

  const onFilterCategoryChanged = (category: any) => {
    setFilterCategory(category);
  };

  const refreshCurrentFolderDocuments = useCallback(() => {
    if (currentFolderId) {
      dispatch(fetchFolder({ folderId: currentFolderId }));
    }
    dispatch(fetchDocuments({} as any));
  }, [currentFolderId, dispatch]);

  const handleShowModal = useCallback(
    (modalAct: any, targetRow?: any) => {
      if (modalAct === documentModalActions.takeReference) {
        const targetDoc = targetRow || selectedRows[0];
        if (!targetDoc) {
          return;
        }
        const fileName = (targetDoc?.name || targetDoc?.originalName || '') as string;
        return dispatch(
          takeReference(targetDoc.id, {
            presentMode: isPresentModePage,
            recycleBin: isRecycleBin,
            fileName,
          }),
        );
      }
      if (modalAct === documentModalActions.takeReferenceWithNames) {
        const targetDoc = targetRow || selectedRows[0];
        if (!targetDoc) {
          return;
        }
        const fileName = (targetDoc?.name || targetDoc?.originalName || '') as string;
        return dispatch(
          takeReferenceWithNames(targetDoc.id, {
            presentMode: isPresentModePage,
            recycleBin: isRecycleBin,
            fileName,
          }),
        );
      }
      if (modalAct === documentModalActions.duplicate) {
        if (!canDuplicateDocuments || !currentFolderId) {
          return;
        }
        const targetDoc = targetRow || selectedRows[0];
        if (!targetDoc?.id) {
          return;
        }
        if (targetRow?.id) {
          setSelectedRows([targetRow]);
        }
      }
      if (modalAct === documentModalActions.removePages) {
        const targetDoc = targetRow || selectedRows[0];
        if (!enableRemovePages || targetDoc?.source === 'merge') {
          return;
        }
      }
      const currentUrlHashVal = window.location.hash;
      const hashFileId = currentUrlHashVal.split('#')[1];
      if (
        (hashFileId && selectedRows.length === 1 && selectedRows[0].id !== hashFileId) ||
        (hashFileId && selectedRows.length !== 1)
      )
        history.push(history.location.pathname, { ...history.location, hash: '' });

      setShowModal(true);
      setModalAction(modalAct);
    },
    [
      canDuplicateDocuments,
      currentFolderId,
      dispatch,
      enableRemovePages,
      isPresentModePage,
      isRecycleBin,
      selectedRows,
    ],
  );
  const query = useSelector(selectQuery);
  const presentView = query && query.presentView === '2';
  const focusedQueryRaw = query?.focused;
  const focusedQueryId = Array.isArray(focusedQueryRaw)
    ? focusedQueryRaw.length > 0 && focusedQueryRaw[0] != null && focusedQueryRaw[0] !== ''
      ? String(focusedQueryRaw[0])
      : null
    : typeof focusedQueryRaw === 'string' || typeof focusedQueryRaw === 'number'
      ? String(focusedQueryRaw)
      : null;
  const isLegacyFocusQueryActive =
    query?.focus === 'true' || query?.focus === true || query?.focus === '1';

  const getFileDetails = useCallback(
    (fileId: string) => {
      if (fileId)
        fetchFileDetails({ fileId }).then((res: any) => {
          dispatch(setCurrentSelectedFile(res));
        });
    },
    [fetchFileDetails, dispatch],
  );

  useEffect(() => {
    resetLateInsertState();
  }, [currentFolderId, resetLateInsertState]);

  useEffect(() => {
    setCreatePlaceholdersModalOpen(false);
  }, [currentFolderId]);

  useEffect(() => {
    //Provide document details to viewer when page is refreshed
    if (
      selectedRows.length === 1 &&
      alreadyOpenFileId === selectedRows[0].id &&
      Object.keys(currentFileMetaData).length === 0
    )
      dispatch(setCurrentSelectedFile(selectedRows[0]));
    else if (
      (isPresentModeWithBackEnd || isDocFinderPage || isSearchModePage) &&
      selectedRows.length === 0 &&
      alreadyOpenFileId &&
      Object.keys(currentFileMetaData).length === 0
    )
      getFileDetails(alreadyOpenFileId);
  }, [
    selectedRows,
    alreadyOpenFileId,
    dispatch,
    currentFileMetaData,
    getFileDetails,
    isPresentModeWithBackEnd,
    isDocFinderPage,
    isSearchModePage,
  ]);

  const docFinderFilter = useSelector(selectDocFinderFilter);

  const isPresenterTools =
    isQuickLinksPage ||
    isPresentModePage ||
    isPresentModeWithBackEnd ||
    isSearchModePage ||
    (!docFinderFilter && isDocFinderPage);
  const shouldUseLateInsertFlow =
    Boolean(
      isAgreedBundle &&
        currentFolder &&
        ['bundle', 'team-bundle', 'private-bundle', 'trialbook', 'court-bundle'].includes(
          (currentFolder as any).type,
        ),
    ) && !isAllDocuments;
  const isIndexFolder = currentFolder && currentFolder.readOnly;
  const { folders: { canUploadDocuments = undefined } = {} } = permissions;

  useEffect(() => {
    if (!shouldUseLateInsertFlow) {
      resetLateInsertState();
    }
  }, [shouldUseLateInsertFlow, resetLateInsertState]);

  const globalPaging = currentFolder && currentFolder.globalPaging;
  const isGlobalPageLookUp = useSelector(selectIsGlobalPageLookup);
  const caseId = useSelector(selectCurrentCaseId);
  const userId = useSelector(selectUserId);
  const {
    uploadComplete,
    uploadInProgress,
    currentBatchId,
    batchSize,
    batchUploadReport,
    proceedToCreateBatch,
    markComplete,
    reset: resetBatchProcess,
  } = useBatchProcess(caseId);

  useIManageBatchUpload(proceedToCreateBatch);

  const openViewerWithFileDetails = useCallback(
    (bundleDetails: any, selectedItems: Array<any>, presentView: string) => {
      const currentFileMetaDataNew: Record<string, any> = {
        ...selectedItems[0],
        ...(bundleDetails && Object.keys(bundleDetails).length > 0 && bundleDetails),
      };
      let urlWithParams: string =
        selectedItems[0].type === fileTypes.mp4
          ? ''
          : currentFileMetaDataNew
            ? `&tab=${currentFileMetaDataNew.tab}&startPage=${currentFileMetaDataNew.startPage}&pageCount=${currentFileMetaDataNew.pageCount}&globalPagePrefix=${currentFileMetaDataNew.globalPagePrefix}`
            : '';

      if (presentView === 'share') {
        urlWithParams += '&view=share';
      }

      // Add exhibitNumber if available
      if (currentFileMetaDataNew?.exhibitNumber) {
        urlWithParams += `&exhibitNumber=${currentFileMetaDataNew.exhibitNumber}`;
      }

      openNewBackgroundTab(
        `/case/${caseId}/files/${selectedItems[0]?.id}?folderId=${
          currentFolder?.id ||
          currentFileMetaDataNew?.bundleLocations[0]?.folderId ||
          currentFileMetaData?.folderId ||
          'notAFolder'
        }${selectedItems[0]?.folderFileId ? `&folderFileId=${selectedItems[0]?.folderFileId}` : ''}${urlWithParams}`,
      );
    },
    [caseId, currentFileMetaData, currentFolder],
  );

  const isTrialBundle = currentFolder && currentFolder.type === 'trialbook';

  const getFolderSpecificFileDetails = useCallback(
    (selectedItems: any[], presentView: string) => {
      if ((isTrialBundle && !globalPaging) || (!isTrialBundle && !isGlobalPageLookUp)) {
        setOpenFileLoading(true);
        fetchFileDetails({
          fileId: selectedItems[0]?.id,
        })
          .then((res: any) => {
            const currentFileFirstTrialBundleLocation =
              res.bundleLocations.find((bundle: any) => bundle.containerType === 'trialbook') || {};
            if (
              currentFileFirstTrialBundleLocation &&
              Object.keys(currentFileFirstTrialBundleLocation).length > 0
            ) {
              dispatch(
                fetchFolderSpecificFileDetails({
                  fileId: selectedItems[0].id,
                  firstTrialbookOnly: false,
                }),
              )
                .then((resp: any) => {
                  const bundleDetails = resp.find(
                    (item: any) => item.folderId === currentFileFirstTrialBundleLocation.folderId,
                  );
                  openViewerWithFileDetails(bundleDetails, selectedItems, presentView);
                })
                .finally(() => {
                  setOpenFileLoading(false);
                });
            } else {
              openViewerWithFileDetails(null, selectedItems, presentView);
              setOpenFileLoading(false);
            }
          })
          .catch(() => {
            setOpenFileLoading(false);
          });
      } else openViewerWithFileDetails(null, selectedItems, presentView);
    },
    [
      dispatch,
      fetchFileDetails,
      fetchFolderSpecificFileDetails,
      globalPaging,
      isGlobalPageLookUp,
      isTrialBundle,
      openViewerWithFileDetails,
    ],
  );

  const [sortMode, setSortMode] = useState(false);
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    const currentPath = history.location.pathname;
    const filesPattern = /\/files\/([^/]+)(?:\/|$)/;
    const match = currentPath.match(filesPattern);
    if (match && currentFileMetaData?.id && documents?.length) {
      const selectedDocuments = documents.filter(
        (doc) =>
          (doc.folderFileId &&
            currentFileMetaData.folderFileId &&
            doc.folderFileId === currentFileMetaData.folderFileId) ||
          // Fall back to id comparison if folderFileId is missing from either object
          ((!doc.folderFileId || !currentFileMetaData.folderFileId) &&
            doc.id === currentFileMetaData.id),
      );
      if (selectedDocuments.length > 0) {
        setSelectedRows(selectedDocuments);
      } else {
        setSelectedRows([{ ...currentFileMetaData }]);
      }
    }
  }, [currentFileMetaData, documents]);

  const [drawerContent, setDrawerContent] = useState<'upload' | 'mapData' | 'imanage' | null>(null);

  const clearAll = useCallback(() => {
    setDrawerContent(null);
    setFileMetadata([]);
    setSelectedRows([]);
    resetBatchProcess();
    dispatch({ type: 'CASE_IMANAGE_BATCH_PAYLOAD_CLEAR', clearStarted: true });
  }, [resetBatchProcess, dispatch]);

  useEffect(() => {
    if (currentFolderId !== prevFolderId) {
      if (drawerContent !== null) {
        dispatch(setLocalUploadDrawer(false, null));
      }
      setDrawerContent(null);
      clearAll();
    }
  }, [currentFolderId, prevFolderId, dispatch, drawerContent, clearAll]);

  useEffect(() => {
    return () => {
      clearAll();
    };
  }, [clearAll]);

  const defaultFilters = useMemo(
    () => ({
      term: '',
      goToGlobalPageIdx: '',
      authors: [] as string[],
      recipients: [] as string[],
      classifyType: [] as string[],
      classifySubtype: [] as string[],
      dateFrom: null as Date | null,
      dateTo: null as Date | null,
      dateFilter: false,
      dateUploadedFrom: null as Date | null,
      dateUploadedTo: null as Date | null,
      dateUploadedFilter: false,
      withAnnotations: false,
      withoutAnnotations: false,
      shared: false,
      notShared: false,
      public: false,
      private: false,
      withPublicHyperlinks: false,
      withoutPublicHyperlinks: false,
      withFlag: false,
      noFlag: false,
      withMerged: false,
      notMerged: false,
      trialBundles: [] as string[],
      teamBundles: [] as string[],
      privateBundles: [] as string[],
      createdBy: [] as string[],
      tags: [] as string[],
    }),
    [],
  );

  const [filter, setFilter] = useState(defaultFilters);
  const [filterOperators, setFilterOperators] = useState<Record<string, 'and' | 'or'>>({});
  const [filterOrder, setFilterOrder] = useState<string[]>([]);
  const [mappedRowsWithErrors, setMappedRowsWithErrors] = useState<any[]>([]);
  const actualFilter = useMemo(
    () => ({ ...diff(defaultFilters, filter) }),
    [defaultFilters, filter],
  );

  const [iManageUrl, setIManageUrl] = useState<string>('');

  const iManageStarted = useSelector((state: any) => state.case.iManageStarted);
  const iManageBatchPayload = useSelector((state: any) => state.case.iManageBatchPayload);
  const iManageFailedDocuments = useSelector((state: any) => state.case.iManageFailedDocuments ?? []);
  const iManageDocumentStatuses = useSelector((state: any) => state.case.iManageDocumentStatuses ?? {});

  const showIManageSummary = Boolean(iManageBatchPayload && iManageFailedDocuments.length > 0);

  const iManageSummarySuccessfulDocs = useMemo(() => {
    if (!iManageStarted || !iManageBatchPayload) return [];
    const failedIds = new Set<string>(iManageFailedDocuments.map((d: any) => d.documentId));
    return iManageStarted.documents.filter((d: any) => !failedIds.has(d.documentId));
  }, [iManageStarted, iManageBatchPayload, iManageFailedDocuments]);

  const handleIManageProceed = useCallback(async () => {
    if (!iManageBatchPayload) return;
    try {
      const folderId = iManageBatchPayload.FolderId ?? iManageBatchPayload.folderId;
      const rootFolderLink = iManageBatchPayload.RootFolderLink ?? iManageBatchPayload.rootFolderLink ?? '';
      const data = (iManageBatchPayload.Data ?? iManageBatchPayload.data ?? []).map((f: any) => ({
        uniqueId: f.UniqueId ?? f.uniqueId,
        fileName: f.FileName ?? f.fileName,
        folderPath: f.FolderPath ?? f.folderPath,
        originalFileName: f.OriginalFileName ?? f.originalFileName,
        rootFolderLink: f.RootFolderLink ?? f.rootFolderLink,
      }));
      await proceedToCreateBatch(folderId, data, rootFolderLink);
    } finally {
      dispatch({ type: 'CASE_IMANAGE_BATCH_PAYLOAD_CLEAR' });
    }
  }, [iManageBatchPayload, proceedToCreateBatch, dispatch]);

  useEffect(() => {
    if (!iManageStarted) return;
    if (!showSidebar) {
      dispatch(setLocalUploadDrawer(true, currentFolder));
    }
    setDrawerContent('imanage');
  }, [iManageStarted, showSidebar, dispatch, currentFolder]);
  const [showAssignFiles, setShowAssignFiles] = useState(false);

  const viewDrawerFileData = useMemo(() => {
    if (!viewDrawerFile) return null;
    const fileId = viewDrawerFile.fileId || viewDrawerFile.id;
    if (!fileId) return null;
    const bundleLoc = (viewDrawerFile.bundleLocations && viewDrawerFile.bundleLocations[0]) || {};
    const globalPagePrefix = viewDrawerFile.globalPagePrefix || bundleLoc.globalPagePrefix;
    const tab = viewDrawerFile.tab ?? bundleLoc.tab;
    const startPage = viewDrawerFile.startPage ?? bundleLoc.startPage;
    const pageCount = viewDrawerFile.pageCount ?? bundleLoc.pageCount;
    const shouldShowGlobalPaging = Boolean(globalPagePrefix);
    return {
      ...viewDrawerFile,
      fileId,
      ...(globalPagePrefix ? { globalPagePrefix } : {}),
      ...(tab != null ? { tab } : {}),
      ...(startPage != null ? { startPage } : {}),
      ...(pageCount != null ? { pageCount } : {}),
      ...(shouldShowGlobalPaging ? { showGlobalPaging: true } : {}),
    };
  }, [viewDrawerFile]);

  const viewDrawerBundleRequestRef = useRef(0);
  useEffect(() => {
    const fileId = viewDrawerFileData?.fileId;
    if (!fileId) {
      setViewDrawerBundleDetails({});
      return;
    }
    const requestId = viewDrawerBundleRequestRef.current + 1;
    viewDrawerBundleRequestRef.current = requestId;
    dispatch(fetchFolderSpecificFileDetails({ fileId, firstTrialbookOnly: true }))
      .then((res: any) => {
        if (viewDrawerBundleRequestRef.current !== requestId) return;
        const bundleDetails = Array.isArray(res) && res.length > 0 ? res[0] : {};
        setViewDrawerBundleDetails(bundleDetails || {});
      })
      .catch(() => {
        if (viewDrawerBundleRequestRef.current !== requestId) return;
        setViewDrawerBundleDetails({});
      });
  }, [dispatch, viewDrawerFileData?.fileId]);

  const viewDrawerDocs = useMemo(
    () =>
      Array.isArray(filteredAndSortedData) && filteredAndSortedData.length > 0
        ? filteredAndSortedData
        : documents,
    [filteredAndSortedData, documents],
  );
  const viewDrawerIndex = useMemo(() => {
    if (!viewDrawerFileData || !Array.isArray(viewDrawerDocs) || viewDrawerDocs.length === 0)
      return -1;
    if (viewDrawerFileData.folderFileId) {
      const idx = viewDrawerDocs.findIndex(
        (doc: any) => doc.folderFileId === viewDrawerFileData.folderFileId,
      );
      if (idx !== -1) return idx;
    }
    if (viewDrawerFileData.compositeKey) {
      const idx = viewDrawerDocs.findIndex(
        (doc: any) => doc.compositeKey === viewDrawerFileData.compositeKey,
      );
      if (idx !== -1) return idx;
    }
    const fallbackId = viewDrawerFileData.fileId || viewDrawerFileData.id || null;
    if (fallbackId) {
      const idx = viewDrawerDocs.findIndex(
        (doc: any) =>
          doc.id === fallbackId ||
          doc.fileId === fallbackId ||
          doc.folderFileId === fallbackId ||
          doc.compositeKey === fallbackId,
      );
      if (idx !== -1) return idx;
    }
    return -1;
  }, [viewDrawerDocs, viewDrawerFileData]);
  const viewDrawerPrev = viewDrawerIndex > 0 ? viewDrawerDocs[viewDrawerIndex - 1] : null;
  const viewDrawerNext =
    viewDrawerIndex >= 0 && viewDrawerIndex < viewDrawerDocs.length - 1
      ? viewDrawerDocs[viewDrawerIndex + 1]
      : null;
  const focusQueryRow = useMemo(() => {
    if (!focusedQueryId) return null;
    const matchFromDocs = Array.isArray(viewDrawerDocs)
      ? viewDrawerDocs.find((doc: any) => matchesFocusParam(doc, focusedQueryId))
      : null;
    if (matchFromDocs) return matchFromDocs;
    if (selectedRows?.length === 1 && matchesFocusParam(selectedRows[0], focusedQueryId))
      return selectedRows[0];
    if (
      currentFileMetaData &&
      Object.keys(currentFileMetaData).length > 0 &&
      matchesFocusParam(currentFileMetaData, focusedQueryId)
    )
      return currentFileMetaData;
    if (viewDrawerFile && matchesFocusParam(viewDrawerFile, focusedQueryId)) return viewDrawerFile;
    return null;
  }, [currentFileMetaData, focusedQueryId, selectedRows, viewDrawerDocs, viewDrawerFile]);
  const buildNavTitle = useCallback((doc: any, labelKey: string) => {
    if (!doc) return null;
    const label = T.translate(labelKey);
    const docId = doc.id || doc.fileId || doc.folderFileId || doc.compositeKey || '';
    const docName =
      typeof doc.name === 'string'
        ? doc.name.trim()
        : typeof doc.fileName === 'string'
          ? doc.fileName.trim()
          : '';
    if (docName && docId) return `${label}: ${docName} /${docId}`;
    if (docName) return `${label}: ${docName}`;
    if (docId) return `${label}: ${docId}`;
    return label;
  }, []);
  const viewDrawerPrevTitle = buildNavTitle(viewDrawerPrev, 'generic.prevDoc');
  const viewDrawerNextTitle = buildNavTitle(viewDrawerNext, 'generic.nextDoc');

  const openUploadDrawer = () => {
    dispatch(setLocalUploadDrawer(true, currentFolder));
    setDrawerContent('upload');
  };

  const openMapDataDrawer = () => {
    dispatch(setLocalUploadDrawer(true, currentFolder));
    setDrawerContent('mapData');
  };

  const handleOpenAssignDocuments = () => {
    dispatch(setLocalUploadDrawer(true, currentFolder));
    setShowAssignFiles(true);
  };

  const handleOpenSidebar = () => {
    openUploadDrawer();
  };

  const buildIManageUrl = () => {
    const segmentByType: Record<string, string> = {
      bundle: 'bundles',
      'team-bundle': 'teamBundles',
      'private-bundle': 'privateBundles',
      trialbook: 'trialbundles',
      'court-bundle': 'court-bundles',
      'group-bundle': 'group-bundles',
    };
    const segment = segmentByType[currentFolder?.type];
    const rootFolderLink =
      segment && currentFolder?.code
        ? `/case/${caseId}/${segment}/${currentFolder.code}`
        : '';
    const base = process.env.IMANAGE_WEB_APP_URL || 'https://dev.imanage.trialviewlive.com';
    return `${base}/FilesUploadDialog/${userId}?caseId=${caseId}&folderId=${currentFolder?.id || ''}&rootFolderLink=${encodeURIComponent(rootFolderLink)}`;
  };

  const handleOpenIManageDrawer = () => {
    const url = buildIManageUrl();
    setIManageUrl(url);
    dispatch(setLocalUploadDrawer(true, currentFolder));
    setDrawerContent('imanage');
  };

  const handleIManageSelectAgain = () => {
    dispatch({ type: 'CASE_IMANAGE_BATCH_PAYLOAD_CLEAR', clearStarted: true });
    handleOpenIManageDrawer();
  };

  const handleCloseSidebar = () => {
    if (uploadComplete) setFileMetadata([]);
    setDrawerContent(null);
    setMappedRowsWithErrors([]);
    dispatch(setLocalUploadDrawer(false, null));
  };

  const toggleSideBar = (toggle: boolean) => {
    if (toggle) openUploadDrawer();
    else handleCloseSidebar();
  };

  const updateFocusQuery = useCallback((nextFocusedId?: string | null) => {
    const location = history.location || window.location;
    const searchParams = new URLSearchParams(location.search || '');
    const currentFocused = searchParams.get('focused');
    const hasLegacyFocus = searchParams.has('focus');

    if (nextFocusedId != null && nextFocusedId !== '') {
      const nextValue = String(nextFocusedId);
      if (currentFocused === nextValue && !hasLegacyFocus) return;
      searchParams.set('focused', nextValue);
      if (hasLegacyFocus) searchParams.delete('focus');
      const nextSearch = searchParams.toString();
      const nextLocation = {
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
        hash: location.hash || '',
        state: (location as any).state,
      };
      history.push(nextLocation);
      return;
    }

    if (!searchParams.has('focused') && !hasLegacyFocus) return;
    searchParams.delete('focused');
    if (hasLegacyFocus) searchParams.delete('focus');
    const nextSearch = searchParams.toString();
    history.replace({
      pathname: location.pathname,
      search: nextSearch ? `?${nextSearch}` : '',
      hash: location.hash || '',
      state: (location as any).state,
    });
  }, []);

  const resetFocusViewChatIfNeeded = useCallback(
    (nextDocId?: string | null) => {
      const currentDocId = getFocusParamId(viewDrawerFile);
      if (!currentDocId || !nextDocId) return;
      if (String(currentDocId) === String(nextDocId)) return;
      dispatch(resetAskAiSse());
      dispatch(clearAISearchState());
    },
    [dispatch, viewDrawerFile],
  );

  const closeGridViewerIfNeeded = useCallback(
    (nextDoc: any) => {
      if (!alreadyOpenFileId) return;
      const nextDocId = nextDoc?.fileId || nextDoc?.id || null;
      if (!nextDocId || String(nextDocId) === String(alreadyOpenFileId)) return;

      const nextPath = history.location.pathname.replace(/\/files.*/, ``);
      const currentState = history.location.state;
      const baseState =
        currentState && typeof currentState === 'object'
          ? (currentState as Record<string, any>)
          : {};
      history.push(nextPath, {
        ...baseState,
        skipAskAiHydration: true,
        skipAskAiReset: true,
      });

      const pathParts = history.location.pathname.split('/');
      const categorySegment = pathParts[3] || null;
      const bundleSegment = pathParts[4] || null;
      if (currentFileMetaData && currentFileMetaData.id) {
        dispatch(setLastSelectedFile(currentFileMetaData, categorySegment, bundleSegment));
      }
      dispatch(setCurrentSelectedFile(null));
      dispatch(setSummaryOpen(false));
      dispatch(setFileToCompare(null));
      if (!isSidebarOpen) dispatch(setSidebarOpen(true));
    },
    [alreadyOpenFileId, currentFileMetaData, dispatch, isSidebarOpen],
  );

  const handleOpenViewDrawer = useCallback(
    (row: any) => {
      if (!row) return;
      const fileId = row.fileId || row.id;
      if (!fileId) return;
      resetFocusViewChatIfNeeded(fileId);
      closeGridViewerIfNeeded(row);
      setViewDrawerFile(row);
      setViewDrawerPending(true);
      setViewDrawerError(false);
      setViewDrawerOpen(true);
      updateFocusQuery(getFocusParamId(row));
    },
    [closeGridViewerIfNeeded, resetFocusViewChatIfNeeded, updateFocusQuery],
  );

  useEffect(() => {
    if (!focusViewBridge) return undefined;
    return focusViewBridge.registerOpenHandler(handleOpenViewDrawer);
  }, [focusViewBridge, handleOpenViewDrawer]);

  const handleCloseViewDrawer = useCallback(() => {
    setViewDrawerPending(false);
    setViewDrawerOpen(false);
    updateFocusQuery(null);
    if (!viewDrawerOpen) {
      setViewDrawerFile(null);
    }
  }, [updateFocusQuery, viewDrawerOpen]);

  const restoreGridViewerAnnotations = useCallback(() => {
    if (!alreadyOpenFileId) return;
    fetchAnnotations({
      file: alreadyOpenFileId,
      privateOnly: false,
      forCompare: false,
    }).catch(() => {});
  }, [alreadyOpenFileId, fetchAnnotations]);

  const handleViewDrawerExited = useCallback(() => {
    setViewDrawerFile(null);
    restoreGridViewerAnnotations();
  }, [restoreGridViewerAnnotations]);

  useEffect(() => {
    if (!viewDrawerOpen) return undefined;
    const unblock = history.block((nextLocation, action) => {
      // Never block browser back/forward while focus view is open.
      if (action === 'POP') return undefined;
      const match = nextLocation.pathname.match(/\/case\/([^/]+)\/files\/([^/?#]+)/);
      if (!match) return undefined;
      const targetCaseId = match[1];
      const targetFileId = match[2];
      if (!targetFileId) return undefined;
      if (caseId && targetCaseId && String(targetCaseId) !== String(caseId)) return undefined;

      resetFocusViewChatIfNeeded(targetFileId);
      closeGridViewerIfNeeded({ id: targetFileId, fileId: targetFileId });
      updateFocusQuery(targetFileId);
      return false;
    });
    return () => unblock();
  }, [
    caseId,
    closeGridViewerIfNeeded,
    resetFocusViewChatIfNeeded,
    updateFocusQuery,
    viewDrawerOpen,
  ]);

  useEffect(() => {
    if (!viewDrawerOpen) return;

    const handleFocusViewLinkClick = (event: MouseEvent) => {
      if (event.defaultPrevented) return;
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const target = event.target as Element | null;
      if (!target) return;
      if (!target.closest('[data-focus-view-root]')) return;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (!anchor) return;

      const rawHref = anchor.getAttribute('href') || anchor.href;
      if (!rawHref) return;

      let targetUrl: URL;
      try {
        targetUrl = new URL(rawHref, window.location.origin);
      } catch {
        return;
      }
      if (targetUrl.origin !== window.location.origin) return;

      const match = targetUrl.pathname.match(/\/case\/([^/]+)\/files\/([^/?#]+)/);
      if (!match) return;
      const targetCaseId = match[1];
      const targetFileId = match[2];
      if (!targetFileId) return;
      if (caseId && targetCaseId && String(targetCaseId) !== String(caseId)) return;

      event.preventDefault();
      event.stopPropagation();

      closeGridViewerIfNeeded({ id: targetFileId, fileId: targetFileId });

      const searchParams = new URLSearchParams(history.location.search || '');
      searchParams.set('focused', targetFileId);
      searchParams.delete('focus');
      const carryParams = ['goToPage', 'tab', 'startPage', 'pageCount', 'globalPagePrefix'];
      carryParams.forEach((param) => {
        const value = targetUrl.searchParams.get(param);
        if (value) searchParams.set(param, value);
        else searchParams.delete(param);
      });
      const nextSearch = searchParams.toString();
      history.push({
        pathname: history.location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
        hash: history.location.hash || '',
        state: history.location.state,
      });
    };

    document.addEventListener('click', handleFocusViewLinkClick, true);
    return () => {
      document.removeEventListener('click', handleFocusViewLinkClick, true);
    };
  }, [caseId, closeGridViewerIfNeeded, viewDrawerOpen]);

  const handleUserKeyPress = useCallback(
    (e: any) => {
      const activeElement = typeof document !== 'undefined' ? document.activeElement : null;
      const targetElement = e?.target as HTMLElement | null;
      const roleIsEditable = (el: HTMLElement | null) => {
        if (!el) return false;
        const role = el.getAttribute('role');
        return role === 'textbox' || role === 'combobox' || role === 'searchbox';
      };
      const elementIsEditable = (el: HTMLElement | null) => {
        if (!el) return false;
        const tagName = el.tagName?.toLowerCase();
        if (tagName === 'input' || tagName === 'textarea' || tagName === 'select') return true;
        if (el.isContentEditable) return true;
        if (el.getAttribute('contenteditable') === 'true') return true;
        return roleIsEditable(el);
      };
      const shouldIgnoreShortcut = elementIsEditable(activeElement as HTMLElement | null);
      const shouldIgnoreTarget = elementIsEditable(targetElement);

      const isFocusViewShortcut =
        e.altKey && e.shiftKey && !e.ctrlKey && !e.metaKey && e.code === 'KeyV';
      if (isFocusViewShortcut && (shouldIgnoreShortcut || shouldIgnoreTarget)) {
        return;
      }

      if (isFocusViewShortcut && viewDrawerOpen) {
        handleCloseViewDrawer();
        return;
      }

      if (
        !(isQuickLinksPage || isPresentModePage || isPresentModeWithBackEnd || isSearchModePage) &&
        selectedRows.length === 1
      ) {
        const isUpdateShortcut = isMacPlatform
          ? e.metaKey && e.ctrlKey && e.code === 'KeyM'
          : e.ctrlKey && e.code === 'KeyM';

        if (isFocusViewShortcut) {
          if (viewDrawerOpen) return;
          const row = selectedRows[0];
          const fileId = row?.fileId || row?.id;
          if (!fileId) return;
          handleOpenViewDrawer(row);
        } else if (isUpdateShortcut) {
          if (alreadyOpenFileId && alreadyOpenFileId !== selectedRows[0].id) {
            history.push(
              history.location.pathname.replace(/\/files.*/, ``) + `/files/${selectedRows[0].id}`,
            );
          }
          handleShowModal(documentModalActions.updateMeta);
        } else if ((e.ctrlKey || e.metaKey) && e.shiftKey && !e.altKey && e.code === 'KeyP') {
          if (showPresentModeWithSearch && canPresentToHearingRoom) {
            getFolderSpecificFileDetails(selectedRows, 'share');
          }
        } else if ((e.ctrlKey || e.metaKey) && e.code === 'Period')
          if (!selectedRows[0].private) {
            let toReplace = `/files/${selectedRows[0].id}?present=public`;
            if (presentView === 'share') {
              toReplace += `&view=share`;
            }
            history.push(history.location.pathname.replace(/\/files.*/, ``) + toReplace);
          }
      }
    },
    [
      canPresentToHearingRoom,
      getFolderSpecificFileDetails,
      handleCloseViewDrawer,
      handleOpenViewDrawer,
      isQuickLinksPage,
      isMacPlatform,
      isPresentModePage,
      isPresentModeWithBackEnd,
      isSearchModePage,
      selectedRows,
      viewDrawerOpen,
      alreadyOpenFileId,
      handleShowModal,
      presentView,
      showPresentModeWithSearch,
    ],
  );

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);

    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  }, [handleUserKeyPress]);

  useEffect(() => {
    if (focusedQueryId) {
      if (!focusQueryRow) return;
      const isSameFocusedDoc = viewDrawerFile && matchesFocusParam(viewDrawerFile, focusedQueryId);
      if (viewDrawerOpen) {
        if (!isSameFocusedDoc) {
          resetFocusViewChatIfNeeded(focusedQueryId);
          setViewDrawerFile(focusQueryRow);
          setViewDrawerPending(true);
          setViewDrawerError(false);
          dispatch(setCurrentSelectedFile(focusQueryRow));
        }
        return;
      }
      handleOpenViewDrawer(focusQueryRow);
      return;
    }
    if (isLegacyFocusQueryActive) {
      if (viewDrawerOpen) return;
      const fallbackRow =
        viewDrawerFile ||
        selectedRows?.[0] ||
        (currentFileMetaData && Object.keys(currentFileMetaData).length > 0
          ? currentFileMetaData
          : null);
      if (!fallbackRow) return;
      handleOpenViewDrawer(fallbackRow);
      return;
    }
    if (viewDrawerOpen) {
      handleCloseViewDrawer();
    }
  }, [
    currentFileMetaData,
    dispatch,
    focusQueryRow,
    focusedQueryId,
    handleCloseViewDrawer,
    handleOpenViewDrawer,
    isLegacyFocusQueryActive,
    resetFocusViewChatIfNeeded,
    selectedRows,
    viewDrawerFile,
    viewDrawerOpen,
  ]);

  const handleViewDrawerEnter = useCallback(() => {
    sidebarWasOpenRef.current = isSidebarOpen;
    setFocusViewEntered(false);
  }, [isSidebarOpen]);

  const handleViewDrawerEntered = useCallback(() => {
    setFocusViewEntered(true);
  }, []);

  const handleViewDrawerExit = useCallback(() => {
    setFocusViewEntered(false);
  }, []);

  useEffect(() => {
    const wasEntered = prevFocusViewEnteredRef.current;
    prevFocusViewEnteredRef.current = focusViewEntered;
    focusViewEnteredRef.current = focusViewEntered;
    viewDrawerOpenRef.current = viewDrawerOpen;

    if (focusViewEntered) {
      // Sidebar hiding disabled for now.
      // if (typeof document !== 'undefined') {
      //   document.body.classList.add('focus-view-open');
      // }
      // if (isSidebarOpen) {
      //   dispatch(setSidebarOpen(false));
      // }
      return;
    }

    // Sidebar hiding disabled for now.
    // if (typeof document !== 'undefined') {
    //   document.body.classList.remove('focus-view-open');
    // }
    // if (wasEntered && sidebarWasOpenRef.current && !isSidebarOpen) {
    //   dispatch(setSidebarOpen(true));
    // }
  }, [dispatch, focusViewEntered, isSidebarOpen, viewDrawerOpen]);

  useEffect(() => {
    return () => {
      // Sidebar hiding disabled for now.
      // if (typeof document !== 'undefined') {
      //   document.body.classList.remove('focus-view-open');
      // }
      // if ((focusViewEnteredRef.current || viewDrawerOpenRef.current) && sidebarWasOpenRef.current) {
      //   dispatch(setSidebarOpen(true));
      // }
    };
  }, [dispatch]);

  const handleViewDrawerViewerReady = useCallback(() => {
    if (!viewDrawerOpen) return;
    setViewDrawerPending(false);
  }, [viewDrawerOpen]);

  const handleViewDrawerViewerError = useCallback(() => {
    if (!viewDrawerOpen) return;
    setViewDrawerPending(false);
    setViewDrawerError(true);
  }, [viewDrawerOpen]);

  const handleViewDrawerPrev = useCallback(() => {
    if (!viewDrawerPrev) return;
    closeGridViewerIfNeeded(viewDrawerPrev);
    setViewDrawerFile(viewDrawerPrev);
    setViewDrawerPending(true);
    setViewDrawerError(false);
    dispatch(setCurrentSelectedFile(viewDrawerPrev));
    updateFocusQuery(getFocusParamId(viewDrawerPrev));
  }, [closeGridViewerIfNeeded, dispatch, updateFocusQuery, viewDrawerPrev]);

  const handleViewDrawerNext = useCallback(() => {
    if (!viewDrawerNext) return;
    closeGridViewerIfNeeded(viewDrawerNext);
    setViewDrawerFile(viewDrawerNext);
    setViewDrawerPending(true);
    setViewDrawerError(false);
    dispatch(setCurrentSelectedFile(viewDrawerNext));
    updateFocusQuery(getFocusParamId(viewDrawerNext));
  }, [closeGridViewerIfNeeded, dispatch, updateFocusQuery, viewDrawerNext]);

  const handleViewDrawerSelectDocument = useCallback(
    (targetDocument: any) => {
      const targetDocId = targetDocument?.id || targetDocument?.fileId;
      if (!targetDocId) return;
      const currentFocusId = getFocusParamId(viewDrawerFile);
      if (currentFocusId && String(currentFocusId) === String(targetDocId)) return;

      const focusParamValue = String(targetDocId);
      const docInDrawerList = Array.isArray(viewDrawerDocs)
        ? viewDrawerDocs.find((doc: any) => matchesFocusParam(doc, focusParamValue))
        : null;
      const docInFolderList = Array.isArray(documents)
        ? documents.find((doc: any) => matchesFocusParam(doc, focusParamValue))
        : null;
      const resolvedDocument = docInDrawerList || docInFolderList;
      const applyFocusDocument = (nextDocument: any) => {
        if (!nextDocument) return;
        closeGridViewerIfNeeded(nextDocument);
        setViewDrawerFile(nextDocument);
        setViewDrawerPending(true);
        setViewDrawerError(false);
        dispatch(setCurrentSelectedFile(nextDocument));
        updateFocusQuery(getFocusParamId(nextDocument));
      };

      if (resolvedDocument) {
        applyFocusDocument(resolvedDocument);
        return;
      }

      fetchFileDetails({ fileId: targetDocId })
        .then((res: any) => {
          applyFocusDocument({
            ...targetDocument,
            ...res,
          });
        })
        .catch((error: any) => {
          console.error('Failed to fetch focus-view attachment details', error);
        });
    },
    [
      closeGridViewerIfNeeded,
      dispatch,
      documents,
      fetchFileDetails,
      updateFocusQuery,
      viewDrawerDocs,
      viewDrawerFile,
    ],
  );

  const filterRef = useRef<any>(null);
  const { showDocFinderFilter } = useSetShowDocFinderFilter();
  const hasOpenFile = !!useSelector(selectCurrentFile);

  const showDocFinderSidebar =
    isDocFinderPage && hasDocFinderFilter && showDocFinderFilter && !hasOpenFile;

  const viewDrawerTitle =
    viewDrawerFile?.name ||
    viewDrawerFile?.originalName ||
    viewDrawerFile?.fileName ||
    viewDrawerFile?.id ||
    '';

  return (
    <div
      className={classnames('case-table-wrapper', {
        'docfinder-shift': showDocFinderSidebar,
        'has-open-file': hasOpenFile,
      })}
      key="table-wrapper"
    >
      <Container fluid className="h-100 mx-2">
        <Row className="table-header-row justify-content-between align-items-center p-2 pl-4">
          <FolderBreadcrumb
            filterCategory={filterCategory}
            selectedRows={selectedRows}
            openDialog={openDialog}
            handleShow={handleShowModal}
            isAllDocuments={isAllDocumentsView}
            isPresenterTools={isPresenterTools}
            category={category}
            getFolderSpecificFileDetails={getFolderSpecificFileDetails}
            openFileLoading={openFileLoading}
            openDialogCR={openDialogCR}
            sortMode={sortMode}
            handleSidebar={handleOpenSidebar}
            isDocFinderPage={docFinderFilter && isDocFinderPage}
            fileCount={documentCount}
            showSidebar={showSidebar}
            batchUploading={uploadInProgress}
            setEditMode={setEditMode}
            editMode={editMode}
            filter={filter}
            setFilter={setFilter}
            filterOperators={filterOperators}
            setFilterOperators={setFilterOperators}
            filterOrder={filterOrder}
            setFilterOrder={setFilterOrder}
            openMapDataDrawer={openMapDataDrawer}
            mappedRowsWithErrors={mappedRowsWithErrors}
            handleOpenAssignDocuments={handleOpenAssignDocuments}
            showAIIcon={showAIIcon}
            handleOpenViewDrawer={handleOpenViewDrawer}
            hideAiToolsForMergedDocuments={hideAiToolsForMergedDocuments}
            openCreatePlaceholdersModal={handleOpenCreatePlaceholdersModal}
            openIManageDrawer={handleOpenIManageDrawer}
          />
        </Row>
        <Row className="secondRow g-0 no-gutters">
          <div className="h-100 col-12 px-0" style={{ flex: '1 1 auto', minWidth: 0 }}>
            <Card
              className={classnames({
                loading: fetchDocumentsPending,
              })}
            >
              {uploadInProgress || uploadComplete ? (
                <UploadStatusWindow
                  uploadComplete={uploadComplete}
                  currentBatchId={currentBatchId}
                  caseId={caseId}
                  uploadInProgress={uploadInProgress}
                  batchUploadReport={batchUploadReport}
                  clearAll={() => { setFileMetadata([]); setSelectedRows([]); resetBatchProcess(); dispatch({ type: 'CASE_IMANAGE_BATCH_PAYLOAD_CLEAR', clearStarted: true }); setDrawerContent(null); dispatch(setLocalUploadDrawer(false, null)); }}
                  batchSize={batchSize}
                />
              ) : iManageStarted && !iManageBatchPayload ? (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                    minHeight: 300,
                    gap: 16,
                  }}
                >
                  <h3 style={{ color: '#908f90', textAlign: 'center', margin: 0 }}>
                    {T.translate('case.batchUpload.iManage.uploadingProgress', {
                      done: Object.values(iManageDocumentStatuses).filter(
                        (s: any) => s === 'Success' || s === 'Failed',
                      ).length,
                      total: iManageStarted.documents.length,
                    })}
                  </h3>
                  <CircularProgress size={36} thickness={4} />
                </div>
              ) : (
                <FileDropZone
                  refLink={dropzoneRef}
                  folderId={currentFolderId}
                  showInfo
                  showProgress
                  onDropCustom={shouldUseLateInsertFlow ? handleLateInsertDrop : undefined}
                  noDrop={
                    !(canUploadDocuments && canUploadDocuments()) ||
                    isPresenterTools ||
                    isIndexFolder
                  }
                  uploadInnerFile={uploadInnerFile}
                  setUploadInnerFile={setUploadInnerFile}
                  showSidebar={showSidebar}
                >
                  <TableCase
                    onRowSelected={onRowSelected}
                    isTrialBooks={isTrialBooks}
                    isAllDocuments={isAllDocumentsView}
                    isRecycleBin={isRecycleBin}
                    onFilterChanged={onFilterChanged}
                    onFilterCategoryChanged={onFilterCategoryChanged}
                    isQuickLinksPage={isQuickLinksPage}
                    isTagsPage={isTagsPage}
                    isPresentModePage={isPresentModePage}
                    isPresentModeWithBackEnd={isPresentModeWithBackEnd}
                    isSearchModePage={isSearchModePage}
                    isAiToolsPage={isAiToolsPage}
                    isDocFinderPage={isDocFinderPage}
                    onQuickUpload={openDialog}
                    gridList={gridList}
                    setGridList={setGridList}
                    sortMode={sortMode}
                    setSortMode={setSortMode}
                    editMode={editMode}
                    setEditMode={setEditMode}
                    filter={filter}
                    setFilter={setFilter}
                    filterOperators={filterOperators}
                    filterOrder={filterOrder}
                    actualFilter={actualFilter}
                    mappedRowsWithErrors={mappedRowsWithErrors}
                    handleShow={handleShowModal}
                    getFolderSpecificFileDetails={getFolderSpecificFileDetails}
                    onOpenViewDrawer={handleOpenViewDrawer}
                  />
                </FileDropZone>
              )}
            </Card>
            {!fetchDocumentsPending && (
              <FolderFooter
                {...(!isTagsPage && { totalPageCount, totalDocumentSize })}
                documentCount={documentCount}
                filteredRowCount={filteredRowCount}
                totalDocumentCount={totalDocumentCount}
                selectedRowsLength={selectedRows.length}
              />
            )}
            <FocusView
              open={viewDrawerOpen}
              onClose={handleCloseViewDrawer}
              onEnter={handleViewDrawerEnter}
              onEntered={handleViewDrawerEntered}
              onExit={handleViewDrawerExit}
              onExited={handleViewDrawerExited}
              title={viewDrawerTitle}
              pending={viewDrawerPending}
              error={viewDrawerError}
              fileData={viewDrawerFileData}
              bundleSpecificFileDetails={viewDrawerBundleDetails}
              onViewerReady={handleViewDrawerViewerReady}
              onViewerError={handleViewDrawerViewerError}
              onPrev={handleViewDrawerPrev}
              onNext={handleViewDrawerNext}
              hasPrev={!!viewDrawerPrev}
              hasNext={!!viewDrawerNext}
              prevTitle={viewDrawerPrevTitle || ''}
              nextTitle={viewDrawerNextTitle || ''}
              zIndex={viewDrawerZIndex}
              isSidebarOpen={false}
              onSelectDocument={handleViewDrawerSelectDocument}
            />
          </div>
          {isDocFinderPage && hasDocFinderFilter && (
            <DocFinderFilters search={actualFilter.term} ref={filterRef} sidebar />
          )}
        </Row>
        <SideDrawer
          showSidebar={drawerContent !== null}
          onClose={handleCloseSidebar}
          title={
            drawerContent === 'mapData'
              ? T.translate('case.batchUpload.dataMapper.title')
              : drawerContent === 'upload'
                ? T.translate('case.batchUpload.title')
                : drawerContent === 'imanage'
                  ? T.translate('case.iManageImport')
                  : ''
          }
        >
          {drawerContent === 'mapData' && (
            <DataMapper
              proceedToCreateBatch={proceedToCreateBatch}
              markComplete={markComplete}
              setMappedRowsWithErrors={setMappedRowsWithErrors}
              mappedRowsWithErrors={mappedRowsWithErrors}
            />
          )}
          {drawerContent === 'upload' && (
            <UploadFileContent
              fileMetadata={fileMetadata}
              setFileMetadata={setFileMetadata}
              currentFolderId={currentFolderId}
              showSidebar={drawerContent !== null}
              uploadComplete={uploadComplete}
              setShowSideBar={toggleSideBar}
              proceedToCreateBatch={proceedToCreateBatch}
              folder={currentFolder}
            />
          )}
          {drawerContent === 'imanage' && (
            <IManageDrawerContent retryUrl={iManageUrl} />
          )}
        </SideDrawer>
      </Container>
      <LateInsertModal
        open={shouldUseLateInsertFlow && lateInsertModalOpen}
        files={lateInsertFiles}
        assignments={lateInsertAssignments}
        defaultTab={'0'}
        existingFiles={existingFiles}
        onAssignmentChange={handleLateInsertAssignmentChange}
        onRemoveFile={handleLateInsertRemoveFile}
        onClose={resetLateInsertState}
        onSubmit={handleLateInsertSubmit}
        submitted={lateInsertSubmitted}
        folderName={currentFolder?.name}
        folderId={currentFolderId}
      />
      <CreatePlaceholdersModal
        open={createPlaceholdersModalOpen}
        folderId={currentFolderId}
        onClose={handleCloseCreatePlaceholdersModal}
        onCreated={refreshCurrentFolderDocuments}
      />
      <IManageJobSummaryDialog
        open={showIManageSummary}
        successfulDocs={iManageSummarySuccessfulDocs}
        failedDocs={iManageFailedDocuments}
        onProceed={handleIManageProceed}
        onSelectAgain={handleIManageSelectAgain}
      />
      {showModal && (
        <DocumentsModal
          handleClose={handleCloseModal}
          handleSave={handleSave}
          show={showModal}
          action={modalAction}
          selectedRows={selectedRows}
          folder={currentFolder}
          filter={filterValue}
          isAllDocuments={isAllDocumentsView}
          isDocFinder={isDocFinderPage}
          currentGridList={gridList}
          fileCount={documentCount}
          onRowSelected={onRowSelected}
        />
      )}
    </div>
  );
};
